import { useEffect } from 'preact/hooks';
import { route } from 'preact-router';

import AppLoader from '@/components/AppLoader';

const CheckoutCompleted = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const passType = params.get('passType');
    const price = params.get('price');
    const redirect = params.get('co-redirect');
    const newPath = `/welcome?plan=${passType}&price=${price}${
      redirect ? `&co-redirect=${encodeURIComponent(redirect)}` : ''
    }`;
    route(newPath, true);
  }, []);
  return <AppLoader />;
};

export default CheckoutCompleted;
